import React, { Fragment, useEffect, useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import styled, {css} from 'styled-components';
import { MetaContext } from "../context";

export function Checkout(props) {
  const context = useContext(MetaContext);
  return (
    <CSSch0>
      <CSSchIfr src={context.state.checkout.webUrl} />
    </CSSch0>
  )
}

const CSSch0 = styled.div`
  position: fixed;
  display: flex;
  z-index:10000;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.5)
`
const CSSchIfr = styled.iframe`
  width: 800px;
  height: 800px;
`